import { useState, useCallback } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { SharedNavbar } from '@/components/SharedNavbar';
import { GlobalToolsExpandingPanel } from '@/components/GlobalToolsExpandingPanel';
import { AttendanceSidebar } from '@/components/AttendanceSidebar';
import { AttendanceDashboard } from './AttendanceDashboard';
import { RequestLeavePage } from './RequestLeavePage';
import { LeaveHistoryPage } from './LeaveHistoryPage';
import { MyCalendarPage } from './MyCalendarPage';
import { TeamOverviewPage } from './TeamOverviewPage';
import { LeaveProfilePage } from './LeaveProfilePage';
import { AllRequestsPage } from './AllRequestsPage';
import { ReportsPage } from './ReportsPage';
import { BankHolidaysPage } from './BankHolidaysPage';
import { EntitlementsPage } from './EntitlementsPage';
import { CalendarNotesPage } from './CalendarNotesPage';
import { SettingsPage } from './SettingsPage';
import { ImportExportPage } from './ImportExportPage';
import { EmploymentTypesPage } from './EmploymentTypesPage';

export const AttendanceRouter = () => {
  const location = useLocation();
  const [globalToolsOpen, setGlobalToolsOpen] = useState(false);

  const handleGlobalToolsToggle = useCallback(() => {
    setGlobalToolsOpen(prev => !prev);
  }, []);

  // Determine current tool based on pathname
  const getCurrentTool = useCallback(() => {
    const path = location.pathname;
    if (path.startsWith('/attendance')) return 'attendance';
    return null;
  }, [location.pathname]);

  return (
    <div className="h-screen flex flex-col overflow-hidden bg-[#fcf8f3]">
      <SharedNavbar
        currentPage="attendance"
        isGlobalToolsOpen={globalToolsOpen}
        onGlobalToolsToggle={handleGlobalToolsToggle}
      />
      <GlobalToolsExpandingPanel
        isOpen={globalToolsOpen}
        onClose={() => setGlobalToolsOpen(false)}
        currentTool={getCurrentTool()}
      />

      <div className="flex flex-1 min-h-0 overflow-hidden">
        {/* Sidebar - controls its own width with animation */}
        <div className="flex-shrink-0 h-full">
          <AttendanceSidebar />
        </div>

        {/* Main Content */}
        <div className="flex-1 overflow-y-auto">
          <div className="container mx-auto px-6 py-8 max-w-7xl">
            <Routes>
              <Route index element={<AttendanceDashboard />} />
              <Route path="request" element={<RequestLeavePage />} />
              <Route path="history" element={<LeaveHistoryPage />} />
              <Route path="calendar" element={<MyCalendarPage />} />
              <Route path="team" element={<TeamOverviewPage />} />
              <Route path="leave-profile/:userId" element={<LeaveProfilePage />} />
              <Route path="requests" element={<AllRequestsPage />} />
              <Route path="reports" element={<ReportsPage />} />
              <Route path="bank-holidays" element={<BankHolidaysPage />} />
              <Route path="entitlements" element={<EntitlementsPage />} />
              <Route path="calendar-notes" element={<CalendarNotesPage />} />
              <Route path="import-export" element={<ImportExportPage />} />
              <Route path="employment-types" element={<EmploymentTypesPage />} />
              <Route path="settings" element={<SettingsPage />} />
              <Route path="*" element={<Navigate to="/attendance" replace />} />
            </Routes>
          </div>
        </div>
      </div>
    </div>
  );
};
